export const apiBaseUrl = process.env.REACT_APP_BASE_URL as string;
export const apiBaseUrlUsers = process.env.REACT_APP_API_BASE_URL_USERS as string;
export const apiBaseUrlForay = process.env.REACT_APP_API_BASE_URL_FORAY as string;
export const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID as string;
export const fbAppId = process.env.REACT_APP_FB_APP_ID_CCF as string;
export const googleAPIKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY_CCF as string;
// export const clientID = process.env.REACT_APP_CLIENT_ID;
